// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__9idU1","label":"LabeledBox_label__2QJpP"};